<div [class]="userDeviceInfo">
  <a class="cart-link" (click)="goToCart()" (mouseenter)="cartLayer = true">
    <span class="cart-txt" [innerHTML]="'TERM.CART' | t"></span>
    <span class="cartCount">{{ carts?.length }}</span>
  </a>
  <div
    class="cart-layer"
    *ngIf="userDeviceInfo === 'pc' && carts?.length && cartLayer && !isCartPage"
    (mouseleave)="cartLayer = false"
  >
    <ul>
      <li *ngFor="let cart of carts | slice: 0:3" [routerLink]="['/product', cart.mapperSaleProduct.productId]">
        <dl>
          <dt>
            <img [src]="cart.mapperSaleProduct.productOption.images[0].endpoint" alt="productImg" />
            <span>{{ cart.quantity }}</span>
          </dt>
          <dd>
            <p>{{ cart.mapperSaleProduct.productOption.brand.englishName }}</p>
            <p>{{ cart.mapperSaleProduct.productOption.englishName }}</p>
            <p *ngIf="cart.mapperSaleProduct.product.productType === PRODUCT_TYPE.OPTION">
              {{ cart.mapperSaleProduct.productOption.englishOptionName }}
            </p>
            <p>
              USD
              <span>{{
                (cart.mapperSaleProduct.productOption.salePriceUSD * cart.quantity
                  ? cart.mapperSaleProduct.productOption.salePriceUSD * cart.quantity
                  : 0
                ).toFixed(2) | currency: 'USD':'':'0.2'
              }}</span>
            </p>
          </dd>
        </dl>
      </li>
    </ul>
    <p [innerHTML]="'CART.MORE_ITEMS' | t: { count: carts.length - 3 }" class="more-txt" *ngIf="carts.length > 3">
      외에 {{ carts.length - 3 }}개 상품이 더 담겨 있습니다.
    </p>
    <dl class="total">
      <dt>Sub Total</dt>
      <dd>
        USD <span>{{ total.summary | currency: 'USD':'':'0.2' }}</span>
      </dd>
    </dl>
    <a (click)="goToCart()" class="go-cart">View Cart</a>
  </div>
</div>
